<template>
  <div class=" overflow-x-hidden">
    <div class="row align-center flex-dir-column align-middle about">
      <div class="spacer"></div>
      <h2 class=" animated wow fadeIn" data-wow-delay="150ms">Kurs Języka Angielskiego</h2>
      <p
        class="afterH2 animated wow fadeIn" data-wow-delay="150ms"
      >Profesjonalne korepetycje językowe z języka angielskiego dla ludzi w każdym wieku z Jaworzna i okolic.</p>
    </div>
    <div class="spacer2"></div>

    <div class="row">
      <div class="columns small-12 medium-6 myCard flex-dir-row flex-container animated wow fadeInLeft">
        <div class="myCard__text text-right">
          <h3>DZIECI I MŁODZIEŻ</h3>
          <p>Kursy i korepetycje dla dzieci i młodzieży w każdym wieku, od przedszkola po liceum. Przygotowania do egzaminów. Odpowiednie podejście i lata doświadczenia w pracy z dziećmi.</p>
        </div>
        <div class="myCard__icon">
          <i class="fas fa-child fa-sm"></i>
        </div>
        <div class="icon_spacer show-for-small-only"></div>
      </div>
      <div class="columns small-12 medium-6 myCard flex-dir-row-reverse flex-container animated wow fadeInRight">
        <div class="myCard__text text-left">
          <h3>DOROŚLI</h3>
          <p>Profesjonalne kursy dla dorosłych, zarówno chcących nauczyć się języka angielskiego od podstaw jak i tych, którzy chcą podnieść już posiadane umiejętności na wyższy poziom.</p>
        </div>
        <div class="myCard__icon">
          <i class="fas fa-user-friends fa-sm"></i>
        </div>
        <div class="icon_spacer show-for-small-only"></div>
      </div>
    </div>
    <div class="row">
      <div class="columns small-12 medium-6 myCard flex-dir-row flex-container animated wow fadeInLeft" data-wow-delay="300ms">
        <div class="myCard__text text-right">
          <h3>DOJAZD DO KLIENTA</h3>
          <p>Możliwość dojazdu do ucznia na terenie Jaworzna i okolic, lub nauka w dogodnych warunkach w moim lokalu.</p>
        </div>
        <div class="myCard__icon">
          <i class="fas fa-car fa-sm"></i>
        </div>
        <div class="icon_spacer show-for-small-only"></div>
      </div>
      <div class="columns small-12 medium-6 myCard flex-dir-row-reverse flex-container animated wow fadeInRight" data-wow-delay="300ms">
        <div class="myCard__text text-left">
          <h3>ATRAKCYJNE CENY</h3>
          <p>Korzystne warunki cenowe, sprawdź sam: zadzwoń lub napisz e-mail wypełniając formularz na dole strony.</p>
        </div>
        <div class="myCard__icon">
          <i class="fas fa-money-bill-wave fa-sm"></i>
        </div>
        <div class="icon_spacer show-for-small-only"></div>
      </div>
      <div class="spacer"></div>
    </div>

    <div class="text-section what-we-do">
      <div class="row align-center flex-dir-column align-middle">
        <h2 class="animated wow fadeInLeft" data-wow-delay="300ms">Kursy dla dzieci</h2>
        <p
          class="content animated wow fadeInRight" data-wow-delay="300ms"
        >Pracuję z dziećmi i młodzieżą w każdym wieku i z wszelkich rodzajów szkół. Począwszy od przedszkoli przez szkoły podstawowe, gimnazja i szkoły ponadgimnazjalne. Przygotowywałem maturzystów, którzy osiągali bardzo dobre wyniki na egzaminach. 
 Posiadam dużo cierpliwości do dzieci a zajęcia są urozmaicone różnymi zabawami językowymi. Możliwość dojazdu do uczniów.</p>
      </div>
    </div>

    <div class="text-section">
      <div class="row align-center flex-dir-column align-middle">
        <h2 class="animated wow fadeInLeft">Więcej o kursie</h2>
        <p
          class="afterH2 animated wow fadeInRight"
        >Udowodnię Ci że języka można się uczyć w każdym wieku. </p>
        <p
          class="content animated wow fadeInLeft"
        >Język angielski jest moją życiową pasją. Posiadam kilkunastoletnie doświadczenie w pracy dydaktycznej w nauczaniu języka angielskiego i udzielaniu korepetycji. Swoje umiejętności doskonaliłem w Anglii i Szkocji. W trakcie korepetycji potrafię stworzyć bardzo miłą i przyjazną atmosferę.
        Przez kilka lat uczyłem też osoby starsze na Uniwersytecie Trzeciego Wieku w Jaworznie. Pozostawiłem po sobie miłe wspomnienia.</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
